import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/share/nginx/html/pwatools/core/tools/videolist/videoList.component.tsx");
